module.exports = __webpack_public_path__ + "img/LTS_SR.7dd98d91.gif";